import { sanitizeSentryEvent } from "@aix/apiutils/src/sentryPrivacy"
import type { Event } from "@sentry/react"
import { some } from "lodash-es"
const isThirdPartyInvalidDataNoise = (event: Event): boolean => {
  return some(event.exception?.values ?? [], (exception) => {
    const isInvalidData = /Invalid data/i.test(exception.value ?? "")
    const hasThirdPartyClientScript = some(exception.stacktrace?.frames ?? [], (frame) => {
      return /\/static\/javascripts\/client_default_[^/]+\.js/i.test(frame.filename ?? "")
    })

    return isInvalidData && hasThirdPartyClientScript
  })
}

export const vidmaxSentryPrivacyOptions = {
  beforeSend<T extends Event>(event: T): T | null {
    if (isThirdPartyInvalidDataNoise(event)) return null
    return sanitizeSentryEvent(event)
  },
  beforeSendTransaction<T extends Event>(event: T): T | null {
    return sanitizeSentryEvent(event)
  },
  sendDefaultPii: false,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
}
